<template>
	<v-toolbar
		flat
		:light="!dark"
		:color="dark ? 'accent darken-2' : 'white'"
		:height="height"
		extension-height="50"
	>
		<v-toolbar-title>
			<div class="v-icon">
				<fa-icon
					:icon="pageIcon"
					fixed-width
					:class="{ 'accent--text': !dark }"
				/>
			</div>
			{{ pageTitle.toUpperCase() }}
		</v-toolbar-title>

		<v-spacer></v-spacer>

		<search-field
			v-if="searchParams.show && this.$vuetify.breakpoint.mdAndUp"
			:placeholder="searchParams.placeholder"
			class="search-field--header"
		></search-field>

		<search-field
			:slot="
				searchParams.show && this.$vuetify.breakpoint.smAndDown
					? 'extension'
					: false
			"
			:placeholder="searchParams.placeholder"
		></search-field>

		<v-btn color="secondary" v-if="showButton" to="/configurator">
			<div class="v-icon v-icon--left">
				<fa-icon :icon="['far', 'plus']" size="xs" />
			</div>
			Build New Quote
		</v-btn>
	</v-toolbar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SearchField from "@components/partials/SearchField";
import { log } from "util";

export default {
	data() {
		return {};
	},

	components: { SearchField },

	computed: {
		...mapGetters(["user", "currentTeam", "dark", "fluid"]),

		height() {
			let height = "74";

			if (this.$vuetify.breakpoint.smAndDown) {
				height = "50";
			}

			return height;
		},

		showButton() {
			return this.getMetaValue("showButton");
		},

		pageTitle() {
			let title = this.getMetaValue("title");

			if (title === "Products") {
				title = "Configurator";
			}
			return title;
		},

		pageIcon() {
			return this.getMetaValue("icon");
		},

		searchParams() {
			return this.getMetaValue("search")
				? this.getMetaValue("search")
				: { show: false };
		}
	},

	methods: {
		...mapActions(["getUserSettings"]),

		getMetaValue(key) {
			let matched = this.getObjectValue("matched", this.$route);
			for (let i = 0; i < matched.length; i++) {
				let value = this.getObjectValue(`meta.${key}`, matched[i]);
				if (value !== null) {
					return value;
				}
			}
			return null;
		}
	},

	created() {
		// this.getUserSettings();
	}
};
</script>
